export interface ServiceFeatureFlags {
  customForms: boolean;
  realCustomerReviews: boolean;
  webshop: boolean;
  customWebSystem: boolean;
  cardPayment: boolean;
  googleMapsReviews: boolean;
  dataManagementAdmin: boolean;
  mapDisplay: boolean;
  extendedWebSupervision: boolean;
  b2bPage: boolean;
}

export type ServiceFeatureFlagKey = keyof ServiceFeatureFlags;

export interface FeatureFlagged {
  flagKey?: ServiceFeatureFlagKey;
}

export const LAUNCH_FEATURE_FLAGS: ServiceFeatureFlags = {
  customForms: false,
  realCustomerReviews: false,
  webshop: false,
  customWebSystem: false,
  cardPayment: false,
  googleMapsReviews: false,
  dataManagementAdmin: false,
  mapDisplay: false,
  extendedWebSupervision: false,
  b2bPage: false,
};

export const HERO_BADGE_FLAG_MAP: Record<string, ServiceFeatureFlagKey> = {
  'Egyedi űrlapok': 'customForms',
  'Valós ügyfélvélemények': 'realCustomerReviews',
};

export const TRUST_BAR_FLAG_MAP: Record<string, ServiceFeatureFlagKey> = {
  'Bankkártyás fizetés': 'cardPayment',
  'Valós ügyfélvélemények': 'realCustomerReviews',
};

export const CONTACT_SITE_TYPE_FLAG_MAP: Record<string, ServiceFeatureFlagKey> = {
  webshop: 'webshop',
  custom: 'customWebSystem',
  b2b: 'b2bPage',
};
